import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Stars
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.createStars()
        // this.setTextures()
        // this.setMaterial()
        // this.setMesh()
    }

    createStars() 
    {
        // Geometry
        const particlesGeometry = new THREE.BufferGeometry()
        const count = 500

        const positions = new Float32Array(count * 3) // Multiply by 3 because each position is composed of 3 values (x, y, z)

        for(let i = 0; i < count * 3; i++) // Multiply by 3 for same reason
        {
            positions[i] = ($fx.rand() - 0.5) * 100 // $fx.rand() - 0.5 to have a random value between -0.5 and +0.5
        }

        particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

        // Material
        const particlesMaterial = new THREE.PointsMaterial({
            size: 0.02,
            sizeAttenuation: true
        })

        this.particles = new THREE.Points(particlesGeometry, particlesMaterial)
        this.scene.add(this.particles)
    }

    update() 
    {
        this.particles.rotateY(0.0001)
    }
}